import React, { useState, useRef, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import JoditEditor from 'jodit-react';
import axios from 'axios';
import { useQueryClient } from '@tanstack/react-query';

const CreatePost = () => {
    const editor = useRef(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const { register, handleSubmit, setValue, reset } = useForm();
    const queryClient = useQueryClient();

    const config = useMemo(() => ({
        readonly: false,
        placeholder: 'Write your technical manuscript...',
        theme: 'dark',
        height: 500,
        buttons: ['source', '|', 'bold', 'italic', 'underline', 'strikethrough', '|', 'font', 'fontsize', 'brush', 'paragraph', '|', 'image', 'table', 'link', '|', 'align', 'undo', 'redo'],
    }), []);

    const onSelectImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
            setValue('featuredImage', file);
        }
    };

    const onSubmit = async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('title', data.title);
        formData.append('description', data.desc);
        formData.append('content', data.content);
        formData.append('featuredImage', data.featuredImage);

        const keywordArray = data.keywords ? data.keywords.split(',').map(k => k.trim()) : [];
        keywordArray.forEach(k => formData.append('keywords[]', k));

        try {
            const response = await axios.post('https://toporion.net/api/blogs/deploy', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.data.success) {
                alert("Protocol Deployed!");
                reset();
                setImagePreview(null);
                queryClient.invalidateQueries(['blogs']);
            }
        } catch (error) {
            console.error("DEPLOY_ERROR:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-7xl mx-auto text-white pb-20 p-6">
            <header className="mb-10 flex justify-between items-center border-b border-white/10 pb-6">
                <div>
                    <h1 className="text-3xl font-black uppercase">Deploy Entry</h1>
                    <p className="text-gray-500 font-mono text-xs mt-1">// OPERATOR: SALMAN HAIDER</p>
                </div>
                <button onClick={handleSubmit(onSubmit)} disabled={loading} className="px-10 py-4 bg-[#00F0FF] text-black font-bold uppercase rounded-lg">
                    {loading ? "Transmitting..." : "Publish to Cloud"}
                </button>
            </header>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                <aside className="lg:col-span-4 space-y-6">
                    <div className="bg-[#18181b] p-6 rounded-2xl border border-white/5">
                        <label className="block text-[10px] font-mono text-gray-500 mb-4 uppercase tracking-widest">// Featured Image</label>
                        <div className="relative border-2 border-dashed border-white/10 rounded-xl aspect-video flex items-center justify-center">
                            {imagePreview ? <img src={imagePreview} className="w-full h-full object-cover" alt="Preview" /> : <span className="text-gray-700 font-mono text-[10px]">UPLOAD_VISUAL.LOG</span>}
                            <input type="file" onChange={onSelectImage} className="absolute inset-0 opacity-0 cursor-pointer" />
                        </div>
                    </div>
                    <div className="bg-[#18181b] p-6 rounded-2xl border border-white/5 space-y-5">
                        <input {...register("title", { required: true })} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-sm" placeholder="Post Title" />
                        <textarea {...register("desc", { required: true })} rows="3" className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-sm" placeholder="SEO Description (Pain points)"></textarea>
                        <input {...register("keywords")} className="w-full bg-black/40 border border-white/10 rounded-lg p-3 text-sm" placeholder="Keyword1, Keyword2, Keyword3" />
                    </div>
                </aside>
                <main className="lg:col-span-8">
                    <JoditEditor ref={editor} config={config} onBlur={(newContent) => setValue("content", newContent)} />
                </main>
            </div>
        </div>
    );
};

export default CreatePost;